import { Component, OnInit, Input } from "@angular/core";
import { Section } from "../../models";
import { AuthorizationService } from "../../services";
import { environment } from "../../../environments/environment";
import * as $ from "jquery";
import * as _ from "lodash";

declare function initializeHealthcareTopBarV2(
  parentContainer: JQuery,
  auth0ClientId: string,
  auth0Domain: string,
  auth0RefreshToken: boolean,
  auth0Scope: string
): Promise<any>;
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  private topBarLoaded = false;

  private _usersClients: any[];
  public get usersClients(): any[] {
    return this._usersClients;
  }
  public set usersClients(value: any[]) {
    this._usersClients = value;
  }
  public clientsLoaded = false;
  @Input() sections: string;

  private sectionsObj: Section[];
  validSections = [];

  constructor(private authorizationService: AuthorizationService) {}

  async ngOnInit() {
    this.sectionsObj = JSON.parse(this.sections);
    if (this.topBarLoaded) {
      return;
    }

    try {
      await this.injectHealthcareTopBar();

      let topBar = await initializeHealthcareTopBarV2(
        $("#healthcareTopBar"),
        environment.auth0.clientId,
        environment.auth0.domain,
        environment.auth0.refreshToken,
        environment.auth0.scope
      );

      await topBar.initialize();
      window["healthcareTopBar"] = topBar;
      this.authorizationService.setHealthcareTopBar(topBar);
      await this.authorizationService.waitUntilReady();

      this.topBarLoaded = true;
      this.setValidSections();

      this.authorizationService.HealthcareTopBar.notifyActivity();
    } catch (error) {
      console.log(error);
    }
  }

  private setValidSections(): void {
    this.validSections = this.sectionsObj.filter(
      (section) =>
        !section.subSection &&
        this.authorizationService.hasFeature(section.feature, true)
    );
  }

  private injectHealthcareTopBar(): Promise<any> {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.async = true;
      script.src = environment.healthcareTopBar;
      script.addEventListener("load", resolve);
      script.addEventListener("error", () => reject("Error loading script."));
      script.addEventListener("abort", () => reject("Script loading aborted."));
      document.body.appendChild(script);
    });
  }

  checkValidLink(feature: string): boolean {
    if (!feature) {
      return false;
    }
    if (!this.authorizationService.hasFeature(feature)) {
      return false;
    }
    return true;
  }
}
